import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { DeliveryNoteNotificationsState } from './delivery-note-notifications.state';
import {
  DeliveryNoteNotificationsInitialState,
  DeliveryNoteNotificationsLoad,
} from './delivery-note-notifications.actions';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common';
import { LatestNotification } from '../../../monitoring/models';
import { DeliveryNoteParams } from '../../models';

@Injectable({ providedIn: 'root' })
export class DeliveryNoteNotificationsFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(DeliveryNoteNotificationsState.getLoaded);
  notifications$: Observable<LatestNotification[]> = this.store.select(DeliveryNoteNotificationsState.getNotifications);

  constructor(private store: Store) {}
  loadAll(params: DeliveryNoteParams): void {
    this.loadNotifications(params);
  }

  setInitialState(): void {
    this.store.dispatch(new DeliveryNoteNotificationsInitialState());
  }
  private loadNotifications(params: DeliveryNoteParams): void {
    this.store.dispatch(new DeliveryNoteNotificationsLoad(params));
  }
}
